var _g, _g2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg109(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 211,
    viewBox: "0 0 195 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2518_1454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.4287,
    y: 42,
    width: 71,
    height: 97,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4287,
    y: 56,
    width: 47,
    height: 38,
    rx: 4,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4287,
    y: 103,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4287,
    y: 112,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4287,
    y: 121,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 68,
    width: 71,
    height: 97,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 87,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 114,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 96,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 123,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 105,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 132,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.4287,
    y: 141,
    width: 47,
    height: 5,
    rx: 2.5,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_2518_1454)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2518_1454)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.202,
    y: 20,
    width: 63.2259,
    height: 63.2259,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 137.816,
    cy: 51.6124,
    r: 18.3355,
    fill: "#C70306"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.428 48.1448C135.327 48.1448 133.618 49.8542 133.618 51.9554C133.618 54.0566 135.327 55.7661 137.428 55.7661C139.53 55.7661 141.239 54.0566 141.239 51.9554C141.239 49.8542 139.53 48.1448 137.428 48.1448ZM139.691 51.2377L136.961 53.9677C136.846 54.0823 136.696 54.1396 136.546 54.1396C136.396 54.1396 136.246 54.0824 136.131 53.9677L135.088 52.9244C134.859 52.6954 134.859 52.3239 135.088 52.0947C135.317 51.8655 135.688 51.8655 135.917 52.0947L136.546 52.723L138.861 50.408C139.09 50.1788 139.462 50.1788 139.691 50.408C139.92 50.637 139.92 51.0085 139.691 51.2377Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.924 47.3816L145.924 47.366C145.915 47.1739 145.909 46.9707 145.906 46.7445C145.889 45.6418 145.013 44.7296 143.91 44.668C141.61 44.5396 139.831 43.7898 138.312 42.3084L138.299 42.296C137.803 41.8414 137.055 41.8414 136.559 42.296L136.546 42.3084C135.026 43.7898 133.247 44.5396 130.948 44.6681C129.845 44.7296 128.968 45.6418 128.952 46.7447C128.949 46.9693 128.943 47.1725 128.934 47.366L128.933 47.4022C128.888 49.747 128.833 52.6652 129.809 55.314C130.346 56.7706 131.159 58.0368 132.225 59.0776C133.44 60.2629 135.031 61.2039 136.954 61.8743C137.016 61.8962 137.081 61.9139 137.147 61.9271C137.241 61.9458 137.335 61.9551 137.429 61.9551C137.523 61.9551 137.617 61.9458 137.71 61.9271C137.776 61.9139 137.842 61.896 137.905 61.874C139.825 61.2023 141.415 60.2609 142.628 59.0757C143.694 58.0346 144.507 56.7682 145.044 55.3112C146.024 52.6545 145.969 49.7308 145.924 47.3816ZM137.429 56.9397C134.68 56.9397 132.444 54.7038 132.444 51.9554C132.444 49.207 134.68 46.9711 137.429 46.9711C140.177 46.9711 142.413 49.207 142.413 51.9554C142.413 54.7038 140.177 56.9397 137.429 56.9397Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.429 112C45.8119 112 40.4287 117.383 40.4287 124C40.4287 130.617 45.8119 136 52.429 136C59.0456 136 64.4287 130.617 64.4287 124C64.4287 117.383 59.0456 112 52.429 112ZM59.5535 121.74L50.9567 130.337C50.5958 130.698 50.1225 130.878 49.6497 130.878C49.1769 130.878 48.704 130.698 48.3432 130.337L45.0579 127.051C44.3362 126.33 44.3362 125.16 45.0579 124.438C45.7792 123.717 46.9492 123.717 47.6709 124.438L49.6497 126.417L56.9405 119.127C57.6617 118.405 58.8317 118.405 59.5535 119.127C60.2752 119.848 60.2752 121.018 59.5535 121.74Z",
    fill: "#E8202D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428711 98C1.42871 99.6667 3.72871 103 4.92871 103C6.42871 103 7.92871 97.5 9.92871 98.5C11.9287 99.5 13.4287 103.5 14.9287 103C16.4287 102.5 17.9287 98 19.4287 98.5C20.9287 99 22.9287 103.5 24.4287 103C24.5954 103.167 25.5287 102.4 27.9287 98",
    stroke: "#E8202D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2518_1454",
    x: 17.4287,
    y: 38,
    width: 134,
    height: 173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2518_1454",
    result: "effect2_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2518_1454",
    result: "effect3_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2518_1454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_2518_1454",
    x: 95.2021,
    y: 18,
    width: 85.2261,
    height: 104.226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2518_1454",
    result: "effect2_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2518_1454",
    result: "effect3_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 28
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2518_1454",
    result: "effect4_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2518_1454",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2518_1454",
    x: 31.2021,
    y: 0,
    width: 163.226,
    height: 163.226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2518_1454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2518_1454",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg109);
export default __webpack_public_path__ + "static/media/svg109.47962bf1ed195228c0e40068263e1efb.svg";
export { ForwardRef as ReactComponent };